import React from 'react'
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Header, Modal, Grid, Message } from 'semantic-ui-react'
import Role from './Role'
import TextEditor from '../../../../common/TextEditor';
class AddPhaseModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      MakeAnotherActivity: false,
      milestoneCheck: false,
      newActivityObj: {},
      isSubmited: false
    }
    this.onSubmitActivity = this.onSubmitActivity.bind(this);
    this.setMilestone = this.setMilestone.bind(this);
    this.setMakeAnotherActivity = this.setMakeAnotherActivity.bind(this);
    this.updateText = this.updateText.bind(this)
  }

  handleClose = () => {
    dispatch.initiatives.addPhaseModalOpen(false);
    this.setState({ 'milestoneCheck': false })
    this.setState({
      MakeAnotherActivity: false
    });
    dispatch.initiatives.setActivityObj({});
  }

  onSubmitActivity(formData) {
    this.setState({ "isSubmited": true })
    let nodeToAdd
    nodeToAdd = {
      name: this.state.name,
      description: this.state.description,
      initiativeId: this.props.selectedDataById._id,
      lastUpdatedBy: this.props.user,
      isParentNode: true,
      isMilestone: this.state.milestoneCheck,
      tagColor: "#ffffff",
      raci: this.state.newActivityObj.raci,
      organizationId: this.props.selectedDataById.organizationId,
      accountId: this.props.selectedDataById.accountId
    }
    if (nodeToAdd.raci && nodeToAdd.raci.a && nodeToAdd.raci.r) {
      dispatch.initiatives.createActivity(nodeToAdd)
      document.getElementById("AddActivityForm").reset();
      this.setState({ 'milestoneCheck': false })
      this.setState({ "isSubmited": false })
    }

  }

  setMilestone(event, data) {
    this.setState({ 'milestoneCheck': data.checked })

  }
  setMakeAnotherActivity(event, data) {
    this.setState({ MakeAnotherActivity: data.checked });
  }

  updateText(data, name) {
    if (name === "Name") {
      this.setState({ name: data })
    } else if (name === "Description") {
      this.setState({ description: data })
    }
  }
  updateNewActivityObject = (payload) => {
    this.setState({ newActivityObj: payload })

  }
  render() {
    const inlineStyle = {
      modal: {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    };
    return (
      <Modal
        style={inlineStyle.modal}
        open={this.props.isAddPhaseModalOpen}
        onClose={this.handleClose}
        size='medium'
        className="basicModal"
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Header content={"Add Phase"} />
        <br /> <br />
        <Form noValidate
          ref={ref => this.form = ref}
          id="AddActivityForm"
          onValidSubmit={(event) => { this.onSubmitActivity(event) }}
        >
          <Modal.Content>
            <Grid>
              <Grid.Row className="">
                <Grid.Column width={16}>
                  <TextEditor
                    name="Name"
                    text={this.state.name}
                    type="text"
                    onChangeText={this.updateText}
                    autoFocus={true}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>

                  <TextEditor
                    name="Description"
                    text={this.state.description}
                    type="textarea"
                    onChangeText={this.updateText}
                  />

                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Grid.Row>
              <Grid.Column width={16} style={{ 'padding': '15px' }}>
                <Role
                  newActivityObj={this.state.newActivityObj}
                  selectedDataById={this.props.selectedDataById}
                  selectedActivityData={this.props.selectedActivityData}
                  RaciUserList={this.props.RaciUserList}
                  updateNewActivityObject={this.updateNewActivityObject}
                  {...this.props}
                />
              </Grid.Column>
            </Grid.Row>

            {!this.state.isSubmited || (this.state.newActivityObj.raci && this.state.newActivityObj.raci.a && this.state.newActivityObj.raci.r) ? '' :
              <Grid.Column width={16}>
                <div style={{ "marginLeft": "9px", "marginRight": "15px" }}>
                  <Message color='red' className="inviteWarning">
                    <span>
                      Activity must have atleast one Accountable and one Responsible.
                        </span>
                  </Message>
                </div>
              </Grid.Column>}

          </Modal.Content>

          <Modal.Actions className="actionInFormcy">
            <Button className="button-submit float-right" id='addbtn' type="submit" disabled={this.props.addPeerBtnStatus}> Add</Button>
            <Button id='cancelBtn' className="button-cancel" onClick={this.handleClose}> Cancel</Button>

          </Modal.Actions>
        </Form>
      </Modal>
    )
  }
}

export default AddPhaseModal

